import React from "react";
import { EmvCard } from "@radarly/models/cards/model";
import { hasComparaisonFragment } from "@radarly/models/fragment";
import { Project } from "@radarly/models/project";
import { useFragmentsData } from "../data";
import Loading from "../loading";
import Inner from "./inner";

interface IProps {
  disableAnimation?: boolean;
  fragments: EmvCard["fragments"];
  project: Project;
  onClickItem: (range?: { from: Date; to: Date }) => void;
  forceReload?: boolean;
}

export default function SharedWidgetsEmvChart({
  fragments,
  project,
  onClickItem,
  forceReload,
  disableAnimation,
}: IProps) {
  const { loading, data, comparaisonData } = useFragmentsData(
    project.id,
    fragments[0],
    fragments[1]
  );
  const showEvolution = hasComparaisonFragment(fragments[0], fragments[1]);

  return (
    <Loading loading={loading} forceReload={forceReload}>
      <Inner
        data={data}
        comparisonData={comparaisonData}
        onClick={onClickItem}
        disableAnimation={disableAnimation}
        showEvolution={showEvolution}
      />
    </Loading>
  );
}
